import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="nav-logo" style={{ color: 'white' }}>
              <img src="/crm-logo.png" alt="CRM Cloud" className="nav-logo-img" />
              CRM Cloud
            </Link>
            <p>{t('footer.description')}</p>
          </div>
          <div className="footer-col">
            <h4>{t('footer.product')}</h4>
            <ul>
              <li><a href="#features">{t('footer.features')}</a></li>
              <li><a href="#pricing">{t('footer.pricing')}</a></li>
              <li><a href="#features">{t('footer.integrations')}</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t('footer.company')}</h4>
            <ul>
              <li><a href="#about">{t('footer.aboutUs')}</a></li>
              <li><a href="#about">{t('footer.blog')}</a></li>
              <li><a href="#contact">{t('footer.contact')}</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t('footer.support')}</h4>
            <ul>
              <li><a href="#features">{t('footer.helpCenter')}</a></li>
              <li><a href="#features">{t('footer.documentation')}</a></li>
              <li><a href="#features">{t('footer.status')}</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} CRM Cloud. {t('footer.rights')}</p>
          <div className="footer-bottom-links">
            <a href="#privacy">{t('footer.terms')}</a>
            <a href="#privacy">{t('footer.privacyShort')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
